// Activity Profiles client API (Batch 40).
import { api } from "@/lib/api";

export async function listActivities(familyId) {
  if (!familyId) return [];
  const { data } = await api.get(`/families/${familyId}/activities`);
  return data || [];
}

export async function getActivity(familyId, activityId) {
  const { data } = await api.get(`/families/${familyId}/activities/${activityId}`);
  return data;
}

export async function createActivity(familyId, body) {
  const { data } = await api.post(`/families/${familyId}/activities`, body);
  return data;
}

export async function updateActivity(familyId, activityId, patch) {
  const { data } = await api.patch(
    `/families/${familyId}/activities/${activityId}`,
    patch,
  );
  return data;
}

export async function deleteActivity(familyId, activityId) {
  const { data } = await api.delete(
    `/families/${familyId}/activities/${activityId}`,
  );
  return data;
}

export async function previewSeasonEvents(familyId, activityId, overrides = null) {
  const { data } = await api.post(
    `/families/${familyId}/activities/${activityId}/generate-events`,
    { dry_run: true, overrides },
  );
  return data; // { preview: [...], count }
}

export async function commitSeasonEvents(familyId, activityId, overrides = null) {
  const { data } = await api.post(
    `/families/${familyId}/activities/${activityId}/generate-events`,
    { dry_run: false, overrides },
  );
  return data; // { committed, calendar_id }
}

export async function logEventFeedback(familyId, eventId, sentiment, note = null) {
  const { data } = await api.post(
    `/families/${familyId}/events/${eventId}/feedback`,
    { sentiment, note },
  );
  return data;
}

export const ACTIVITY_CATEGORIES = [
  { key: "sport",    label: "Sport",    icon: "trophy",        color: "#ef4444" },
  { key: "music",    label: "Music",    icon: "music",         color: "#8b5cf6" },
  { key: "academic", label: "Academic", icon: "graduation-cap",color: "#3b82f6" },
  { key: "art",      label: "Art",      icon: "palette",       color: "#ec4899" },
  { key: "club",     label: "Club",     icon: "users",         color: "#10b981" },
  { key: "other",    label: "Other",    icon: "calendar",      color: "#f59e0b" },
];

export const SESSION_KINDS = [
  { key: "practice", label: "Practice" },
  { key: "game",     label: "Game" },
  { key: "lesson",   label: "Lesson" },
  { key: "meet",     label: "Meet" },
  { key: "class",    label: "Class" },
  { key: "other",    label: "Other" },
];

export const WEEKDAYS = [
  { idx: 0, short: "Mon", long: "Monday" },
  { idx: 1, short: "Tue", long: "Tuesday" },
  { idx: 2, short: "Wed", long: "Wednesday" },
  { idx: 3, short: "Thu", long: "Thursday" },
  { idx: 4, short: "Fri", long: "Friday" },
  { idx: 5, short: "Sat", long: "Saturday" },
  { idx: 6, short: "Sun", long: "Sunday" },
];
